"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var playlistCodes = exports.playlistCodes = {
  loginRequired: 3,
  registrationRequired: 11,
  contentLocked: 12,
  notAvailable: 8,
  userConsentRequired: 13
};

var importRecipientsCodes = exports.importRecipientsCodes = {
  invalidContact: 5,
  emailExists: 6,
  groupEmailExists: 3,
  recipientExists: 2
};

var downloadTracksCodes = exports.downloadTracksCodes = {
  emailSent: 3,
  needLogin: 3,
  requireAuth: 30
};

var loginCodes = exports.loginCodes = {
  reset: 90,
  unlock: 91
};

var allCodes = {
  success: 0,
  sessionError: 1,
  playlistCodes: playlistCodes,
  importRecipientsCodes: importRecipientsCodes,
  downloadTracksCodes: downloadTracksCodes,
  loginCodes: loginCodes
};

exports.default = allCodes;


//////////////////
// WEBPACK FOOTER
// ./src/helpers/responseCodes.js
// module id = 99
// module chunks = 1